import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./list-name-section.scss";
import {bindInput} from "../../../../../../../../react/bind-input";
import {UseState} from "../../../../../../../../react/use-state";

export const ListNameSection = ({next}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => next({
        getSubmitData: () => state.value,
        valid: true,
        render: ({defaultListName}) => (
            <div className="list-name-section-0n5">
                <div className="header">
                    <div className="title" xd-qa-type="label" xd-qa-name="Neighborhood Search List Name">
                        List Name
                    </div>
                </div>

                <div className="control">
                    <input {...{
                        ...bindInput(state),
                        placeholder: defaultListName,
                        maxLength: 50,
                        "xd-qa-type": "text_field",
                        "xd-qa-name": "Neighborhood Search List Name",
                    }}/>
                </div>
            </div>
        ),
    }),
);
